import { Layout } from 'widgets/layout';

const App = () => {
    return <Layout />;
};
export default App;
